/**
 * SB Admin sidebar behaviour (was sb-admin.js): mark the active nav link and toggle the sidebar.
 */
export function initSidebar() {
    const path = window.location.href;
    document.querySelectorAll('#layoutSidenav_nav .sb-sidenav a.nav-link').forEach((a) => {
        if (a.href === path) a.classList.add('active');
    });
    const toggle = document.getElementById('sidebarToggle');
    if (toggle) {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('sb-sidenav-toggled');
        });
    }
}
